<template>
  <div class="ticket-manage">
    <div class="manage-query">
      <el-form :inline="true" :model="query" ref="queryForm" size="small" class="query-middle">
        <el-form-item label="成行团号：">
          <el-input v-model="query.RegimentNo"></el-input>
        </el-form-item>
        <el-form-item label="合同编号：" style="margin-left: 15px">
          <el-input v-model="query.ContractNo"></el-input>
        </el-form-item>
        <el-form-item label="线路名称：" style="margin-left: 15px">
          <el-input v-model="query.lineName"></el-input>
        </el-form-item>
        <el-form-item label="订单时间：" style="margin-left: 15px">
          <el-date-picker
            v-model="query.StartTime"
            type="date"
            style="width: 180px"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="—">
          <el-date-picker
            v-model="query.EndTime"
            type="date"
            style="width: 180px"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item style="margin-left: 15px">
          <el-button type="primary" icon="el-icon-search" @click="getOrders">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" icon="el-icon-circle-close" @click="resetForm('queryForm')">清除</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="manage-content">
      <div class="main-left">
        <div class="main-title">
          <span> <i class="el-icon-folder-opened"></i> 订单列表 </span>
          <el-button-group>
            <router-link to="/order-input">
              <el-button type="primary" size="mini" icon="el-icon-circle-plus-outline">新增</el-button>
            </router-link>
          </el-button-group>
        </div>
        <div class="left-table">
          <el-table
            :data="tableData"
            height="753px"
            v-loading="loadingTable"
            border
            style="width: 100%"
            :default-sort="{ prop: 'OrderTime', order: 'descending' }"
          >
            <el-table-column type="selection" min-width="10" align="center"></el-table-column>
            
            <el-table-column label="游客手机" prop="Tel" min-width="200" align="center"></el-table-column>
            <el-table-column label="线路名称" prop="Name" min-width="180" align="center"></el-table-column>
            <el-table-column label="游玩时间" prop="PlayTime" min-width="140" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.PlayTime | dateFormatTemp }}</p>
              </template>
            </el-table-column>
            <el-table-column label="成行团号" prop="RegimentNo" min-width="200" align="center"></el-table-column>
            <el-table-column label="订单时间" prop="OrderTime" min-width="140" align="center">
              <template slot-scope="scope">
                <p>{{ scope.row.OrderTime | dateFormat }}</p>
              </template>
            </el-table-column>
            
            <el-table-column label="人数" prop="TotoalCount" min-width="60" align="center"></el-table-column>
            <el-table-column label="状态" prop="Status" min-width="140" fixed="right">
              <template slot-scope="scope">
                <el-tag :type="scope.row.Status | keyToVal(orderType)" effect="dark" size="small">{{
                  scope.row.Status | keyToVal(orderStatus)
                }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column label="操作" min-width="220" align="center" fixed="right">
              <template slot-scope="scope">
                <el-row type="flex" class="row-bg" justify="space-around">
                  <el-button size="mini" type="primary" v-on:click="getDetail(scope.row)">查看</el-button>
                  <el-popconfirm
                    title="确认取消吗？"
                    v-on:onConfirm="cancelOrder(scope.row)"
                    v-if="scope.row.Status != 2 && scope.row.Status != 1 && scope.row.Status != -2"
                  >
                    <el-button size="mini" type="warning" slot="reference">取消订单</el-button>
                  </el-popconfirm>

                  <el-popconfirm
                    title="确认删除吗？"
                    v-on:onConfirm="deleteOrder(scope.row)"
                    v-if="scope.row.Status != -1"
                  >
                    <el-button size="mini" type="danger" slot="reference">删除</el-button>
                  </el-popconfirm>
                </el-row>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="left-pagination">
          <el-pagination
            class="pagination-bottom"
            background
            layout="prev, pager, next, total,sizes,jumper"
            :total="pagination.total"
            :page-size="pagination.PageSize"
            :page-sizes="[10, 20, 50]"
            :current-page.sync="pagination.PageIndex"
            v-on:size-change="handlePageSize"
            v-on:current-change="handlePageIndex"
          ></el-pagination>
        </div>
      </div>
      <div class="main-right">
        <div class="main-title">
          <span> <i class="el-icon-document"></i> 查看 </span>
          <el-button-group>
            <el-button type="warning" v-show="flag === 1 && detail.Status === 0" size="mini" @click="flag = 2"
              >编辑</el-button
            >
            <el-button type="success" v-show="flag === 2" size="mini" @click="submitForm('updateForm')">保存</el-button>
          </el-button-group>
        </div>
        <div class="right-table">
          <table class="input-form" v-show="flag == 1" v-loading="loadingLook">
            <thead>
              <th colspan="6" class="emphasis">订单详情（查看）</th>
            </thead>
            <tbody>
              <tr style="height: 41px">
                <td style="min-width: 120px">游玩线路</td>
                <td class="emphasis">{{ detail.LineName }}</td>
                <td style="min-width: 120px">游玩时间</td>
                <td class="emphasis">
                  {{ detail.PlayTime + ' 至 ' + detail.EndTime }}
                </td>
                <td style="min-width: 120px">同行总人数(含本人)</td>
                <td style="min-width: 40px" class="emphasis">
                  {{ detail.TotoalCount }}
                </td>
              </tr>
              <tr style="height: 41px">
                <td style="min-width: 120px">成人票（人）</td>
                <td style="min-width: 40px" class="emphasis">
                  {{ detail.AdultCount }}
                </td>
                <td style="min-width: 120px">儿童票（人）</td>
                <td class="emphasis" style="min-width: 40px">
                  {{ detail.ChildrenCount }}  
                </td>
                <td style="min-width: 120px">老年人票（人）</td>
                <td class="emphasis">{{ detail.ElderlyCount }}</td>
              </tr>
              <tr style="height: 41px">
                <td style="min-width: 120px">成人价格（元）</td>
                <td style="min-width: 40px" class="emphasis">
                  {{ detail.AdultPrice }}
                </td>
                <td style="min-width: 120px">儿童价格（元）</td>
                <td class="emphasis" style="min-width: 40px">
                  {{ detail.ChildrenPrice }}
                </td>
                <td style="min-width: 120px">老年人价格（元）</td>
                <td class="emphasis" style="min-width: 40px">
                  {{ detail.ElderlyPrice }}
                </td>
              </tr>
              <tr style="height: 41px">
                <td style="min-width: 120px">总价（元）</td>
                <td class="emphasis">{{ detail.AllPrice }}</td>
                <td style="min-width: 120px">餐厅名称</td>
                <td style="min-width: 40px" class="emphasis">
                  {{ detail.RestaurantName }}
                </td>
                <td style="min-width: 120px">餐饮价格（元）</td>
                <td class="emphasis" style="min-width: 40px">
                  {{ detail.RestaurantPrice }}
                </td>
              </tr>
              <tr>
                <td colspan="6" class="emphasis">信息来源</td>
              </tr>
              <tr style="height: 41px">
                <td style="min-width: 120px">线上</td>
                <td class="emphasis" colspan="5">
                  <el-radio-group v-model="detail.OnLine">
                    <el-radio label="同程" disabled>同程</el-radio>
                    <el-radio label="飞猪" disabled>飞猪</el-radio>
                    <el-radio label="携程" disabled>携程</el-radio>
                    <el-radio label="途牛" disabled>途牛</el-radio>
                    <el-radio label="驴妈妈" disabled>驴妈妈</el-radio>
                  </el-radio-group>
                </td>
              </tr>
              <tr>
                <td style="min-width: 120px">微信公众号</td>
                <td colspan="2" class="emphasis" style="min-width: 40px">
                  {{ detail.WeChatAccount }}
                </td>
                <td style="min-width: 120px">其他</td>
                <td colspan="2" class="emphasis" style="min-width: 40px">
                  {{ detail.Other }}
                </td>
              </tr>
              <tr>
                <td style="min-width: 120px">线下</td>
                <td colspan="2" class="emphasis" style="min-width: 40px">
                  {{ detail.Offline }}
                </td>
                <td style="min-width: 120px">个人</td>
                <td colspan="2" class="emphasis" style="min-width: 40px">
                  {{ detail.Personal }}
                </td>
              </tr>
              <tr>
                <td colspan="6" class="emphasis">行程安排</td>
              </tr>
              <tr style="height: 45px">
                <td colspan="6"></td>
              </tr>
              <div class="subtable-tab">
                <div
                  v-for="(item, index) in table"
                  :key="index"
                  class="mouse-pointer tab-item"
                  :class="{ 'sub-selected': currentSubId === item.id }"
                  @click="switchSubtable(item.id)"
                >
                  <div>第{{ item.id + 1 }}天</div>
                </div>
              </div>
              <tr>
                <td colspan="2">行程项目</td>
                <td colspan="2">行程时间(分钟)</td>
                <td colspan="2">行程类型</td>
              </tr>
              <tr v-for="item in table[currentSubId].arrangement" :key="item.proId">
                <td colspan="2">{{ item.Projects }}</td>
                <td colspan="2">
                  {{ item.TimeSpan }}
                  <!-- {{ item.StartTime | getProjectTime(item.EndTime) }} -->
                </td>
                <td colspan="2">
                  {{ item.PointId | getProjectType(options.projects) }}
                </td>
              </tr>
              <tr v-if="detail.RemarkTrip&&detail.RemarkTrip!=''&&detail.RemarkTrip!=undefined&&detail.RemarkTrip.length > 0">
                <td colspan="2">备注行程</td>
                <td colspan="4">{{detail.RemarkTrip}}(分钟)</td>
              </tr>
              <tr>
                <td :rowspan="detail.newListTourist.length + 1" class="emphasis">
                  游客信息
                </td>
                <td>游客姓名</td>
                <td>手机号</td>
                <td colspan="2">游客证件</td>
                <td>团队负责人</td>
              </tr>
              <tr v-for="(item, index) in detail.newListTourist" :key="index + 1">
                <td>{{ item.Name }}</td>
                <td>{{ item.Tel }}</td>
                <td>{{ item.CertificatesType }}</td>
                <td>{{ item.IDNumber }}</td>
                <!-- <td colspan="2">{{ item.IDNumber }}</td> -->
                <td>{{ item.IsMain == false ? '否' : '是' }}</td>
              </tr>
            </tbody>
          </table>
          <el-row type="flex" justify="start" style="margin-top: 30px;margin-bottom:50px;" v-show="flag == 1">
            <el-button @click="contractDialog = true" type="success">查看合同</el-button>
          </el-row>
          <table class="input-form" v-show="flag == 2">
            <thead>
              <th colspan="6" class="emphasis">订单详情（修改）</th>
            </thead>
            <tbody>
              <tr>
                <td style="min-width: 120px">游玩线路</td>
                <td>
                  <el-select v-model="detail.LineId" filterable placeholder="根据线路名搜索" @change="setRouteInfo">
                    <el-option
                      v-for="item in options.routes"
                      :key="item.Id"
                      :label="item.Name"
                      :value="item.Id"
                    ></el-option>
                  </el-select>
                </td>
                <td style="min-width: 120px">游玩日期</td>
                <td>
                  <el-date-picker
                    v-model="detail.PlayTime"
                    type="date"
                    placeholder="请选择游玩日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    @focus="PlayTimeFocus"
                  ></el-date-picker>
                </td>
                <td style="min-width: 120px">同行总人数(含本人)</td>
                <td>
                  <el-input-number v-model="detail.TotoalCount" :min="1" disabled></el-input-number>
                </td>
              </tr>
              <tr>
                <td style="min-width: 120px">成人票（人）</td>
                <td>
                  <el-input-number v-model="detail.AdultCount" :min="0" @input="AdultCountChange"></el-input-number>
                </td>
                <td style="min-width: 120px">儿童票（人）</td>
                <td>
                  <el-input-number
                    v-model="detail.ChildrenCount"
                    :min="0"
                    @input="ChildrenCountChange"
                  ></el-input-number>
                </td>
                <td style="min-width: 120px">老年人票（人）</td>
                <td>
                  <el-input-number v-model="detail.ElderlyCount" :min="0" @input="ElderlyCountChange"></el-input-number>
                </td>
              </tr>
              <tr>
                <td style="min-width: 120px">成人价格（元）</td>
                <td>
                  <el-input-number
                    v-model="detail.AdultPrice"
                    :min="0"
                    :precision="2"
                    @input="AdultPriceChange"
                  ></el-input-number>
                </td>
                <td style="min-width: 120px">儿童价格（元）</td>
                <td>
                  <el-input-number
                    v-model="detail.ChildrenPrice"
                    :min="0"
                    :precision="2"
                    @input="ChildrenPriceChange"
                  ></el-input-number>
                </td>
                <td style="min-width: 120px">老年人价格（元）</td>
                <td>
                  <el-input-number
                    v-model="detail.ElderlyPrice"
                    :min="0"
                    :precision="2"
                    @input="ElderlyPriceChange"
                  ></el-input-number>
                </td>
              </tr>
              <tr>
                <td style="min-width: 120px">总价（元）</td>
                <td>
                  <el-input-number v-model="detail.AllPrice" :min="0" :precision="2" disabled></el-input-number>
                </td>
                <td style="min-width: 120px">餐厅名称</td>
                <td>
                  <el-input v-model="detail.RestaurantName" placeholder="请输入餐厅名称"></el-input>
                </td>
                <td style="min-width: 120px">餐饮价格（元）</td>
                <td>
                  <el-input-number v-model="detail.RestaurantPrice" :min="0" :precision="2"></el-input-number>
                </td>
              </tr>

              <tr>
                <td colspan="6" class="emphasis">信息来源</td>
              </tr>
              <tr style="height: 41px">
                <td style="min-width: 120px">线上</td>
                <td colspan="5">
                  <el-radio-group v-model="detail.OnLine" @change="selOnline">
                    <el-radio label="同程">同程</el-radio>
                    <el-radio label="飞猪">飞猪</el-radio>
                    <el-radio label="携程">携程</el-radio>
                    <el-radio label="途牛">途牛</el-radio>
                    <el-radio label="驴妈妈">驴妈妈</el-radio>
                  </el-radio-group>
                </td>
              </tr>
              <tr>
                <td style="min-width: 120px">微信公众号</td>
                <td colspan="2">
                  <el-input
                    v-model="detail.WeChatAccount"
                    placeholder="请输入微信公众号"
                    @input="WeChatAccountChange"
                  />
                </td>
                <td style="min-width: 120px">其他</td>
                <td colspan="2">
                  <el-input placeholder="请输入其他" v-model="detail.Other" @input="OtherChange" />
                </td>
              </tr>
              <tr>
                <td style="min-width: 120px">线下</td>
                <td colspan="2">
                  <el-input v-model="detail.Offline" placeholder="请输入旅行社" @input="OfflineChange" />
                </td>
                <td style="min-width: 120px">个人</td>
                <td colspan="2">
                  <el-input v-model="detail.Personal" placeholder="请输入个人" @input="PersonalChange" />
                </td>
              </tr>
              <tr>
                <td colspan="6" class="emphasis">行程安排</td>
              </tr>
              <tr style="height: 45px">
                <td colspan="6"></td>
              </tr>
              <div class="subtable-tab1">
                <div
                  v-for="(item, index) in table"
                  :key="index"
                  class="mouse-pointer tab-item"
                  :class="{ 'sub-selected': currentSubId === item.id }"
                  @click="switchSubtable(item.id)"
                >
                  <div>第{{ item.id + 1 }}天</div>
                </div>
              </div>
              <tr>
                <td colspan="2">行程项目</td>
                <td colspan="2">行程时间</td>
                <td colspan="2">行程类型</td>
              </tr>
              <tr v-for="item in table[currentSubId].arrangement" :key="item.proId">
                <td colspan="2">{{ item.Projects }}</td>
                <td colspan="2">
                  {{ item.StartTime | getProjectTime(item.EndTime) }}
                </td>
                <td colspan="2">
                  {{ item.PointId | getProjectType(options.projects) }}
                </td>
              </tr>
              <tr>
                <td :rowspan="detail.newListTourist.length + 1" class="emphasis">
                  游客信息
                </td>
                <td>游客姓名</td>
                <td>手机号</td>
                <td colspan="2">游客证件</td>
                <td>团队负责人</td>
              </tr>
              <tr v-for="(item, index) in detail.newListTourist" :key="index + 1">
                <td>
                  <el-input v-model="item.Name" placeholder="请输入游客姓名"></el-input>
                </td>
                <td>
                  <el-input v-model="item.Tel" placeholder="请输入游客手机号"></el-input>
                </td>
                <td>
                    <el-select v-model="item.CertificatesType" placeholder="请选择证件类型">
                    <el-option
                      v-for="item in optionsType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </td>
                <td>
                  <el-input v-model="item.IDNumber" placeholder="请输入游客证件"></el-input>
                </td>
                <td>
                  <el-checkbox v-model="item.IsMain" @change="switchMainVisitor(item)">是</el-checkbox>
                </td>
              </tr>
              <tr>
                <td colspan="6">
                  <el-button-group>
                    <el-button type="success" size="mini" @click="handleVisitor('plus')" v-if="false"
                      >扫描身份证</el-button
                    >
                    <el-button type="primary" size="mini" @click="handleVisitor('plus')">继续添加</el-button>
                    <el-button type="success" size="mini" @click="handleVisitor('plus')" v-if="false"
                      >批量导入</el-button
                    >
                    <el-button type="danger" size="mini" @click="handleVisitor('minus')">删除行</el-button>
                  </el-button-group>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="contractDialog" >
      <contract-detail :orderId="detail.orderId" v-if="contractDialog"></contract-detail>
      <div class="btn">
        <el-button @click="contractDialog = false"><a style="color: #000">取 消</a></el-button>
        <el-button v-if="contractInfo.ContactAttachment"
          ><a
            :href="'/api/co/Order/DownLoadOneDayContact?orderId=' + contractInfo.orderId + '&sessionId=' + sessionId"
            style="color: #000"
            >下载合同</a
          ></el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getToken, getCookie } from '@/common/auth'
import ValidationProvider from '@/common/vee-validator'
import { ValidationObserver } from 'vee-validate'
import { mapState } from 'vuex'
import { keyToVal, dateFormat,dateFormatTemp } from '@/filters/filters'
import ContractDetail from '@/components/Contract.vue'
import Order from '@/api/order'
import ROUTE from '@/api/route'
export default {
  name: 'OrderManage',
  data() {
    return {
        optionsType:[{
          value: '身份证',
          label: '身份证'
        }, {
          value: '港澳通行证',
          label: '港澳通行证'
        }, {
          value: '台湾通行证',
          label: '台湾通行证'
        },{
          value: '护照',
          label: '护照'
      }],


      contractInfo: {},
      sessionId: '',

      query: {
        RegimentNo: '', //编号
        ContractNo:"",//合同编号
        lineName: '',
        StartTime: '',
        EndTime: '',
        PageSize: 10,
        PageIndex: 1,
      },
      flag: 0,
      config: {
        LineId: '线路名称', //线路Id
        PlayTime: '游玩时间', //游玩时间
        TotoalCount: '同行总人数(含本人)', //总人数(含自己)
        AdultCount: '成人票', //成人个数
        ChildrenCount: '儿童票', //儿童个数
        ElderlyCount: '老年人票', //老年人个数
        AdultPrice: '成人价格', //成人价格
        ChildrenPrice: '儿童价格', //儿童价格
        ElderlyPrice: '老年人价格', //老年人价格
        AllPrice: '总价格', //总价格
        RestaurantPrice: '餐饮价格', //餐饮价格
      },
      detail: {
        Status: '',
        RestaurantName: '', //餐厅名称
        RestaurantPrice: 0, //餐饮价格
        AdultPrice: 0, //成人价格
        ChildrenPrice: 0, //儿童价格
        ElderlyPrice: 0, //老年人价格
        AllPrice: 0, //总价格
        AdultCount: 0, //成人个数

        orderId: '', //订单Id
        LineId: '', //线路Id
        LineName: '',
        PlayTime: '', //游玩时间
        EndTime: '', //结束时间
        TotoalCount: 0, //总人数
        ElderlyCount: 0, //免票数
        ChildrenCount: 0, //半票数

        OnLine: '', //线上
        WeChatAccount: '', //微信公众号
        Offline: '', //线下
        Personal: '', //个人
        Other: '',
        RemarkTrip:"",

        //游客信息表
        newListTourist: [{ Name: '', Tel: '', IDNumber: '',CertificatesType:'身份证' }],
      },
      model: {
        startPoint: '', //起点
        endPoint: '', //终点
        company: { Id: '', Name: '' }, //公司Id,Name
        endDate: '', //结束时间
      },
      contractDialog: false,
      tableData: [],
      pagination: {
        total: 0,
        PageSize: 10,
        PageIndex: 1,
      },
      mainSelected: true, //校验是否选择主要游客,修改默认为有主要游客
      currentSubId: 0,
      table: [
        {
          id: 0,
          arrangement: [],
        },
      ],

      loadingTable:false,
      loadingLook:false,
    }
  },
  filters: {
    keyToVal,
    dateFormat,
    dateFormatTemp,
    getProjectType(value, projects) {
      for (const pro of projects) {
        if (pro.Id == value) {
          return pro.Type
        }
      }
      return ''
    },
    getProjectTime(start, end) {
      let startTime = +start,
        endTime = +end
      if (isNaN(startTime) || isNaN(endTime)) return ''
      return `${parseInt(startTime / 60)}:${(startTime % 60).toString().padStart(2, '0')} 
      至 ${parseInt(endTime / 60)}:${(endTime % 60).toString().padStart(2, '0')}`
    },
  },
  computed: {
    ...mapState('trip', {
      options: (state) => {
        return {
          routes: state.routes,
          projects: state.projects,
        }
      },
    }),
    ...mapState('common', ['orderStatus', 'orderType']),
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    ContractDetail,
  },
  created() {
    this.getOrders()
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (to.query.type === 'add') {
        let today = new Date()
        vm.query.StartTime = `${today.getFullYear()}-${today.getMonth()}-${today.getDate()} 00:00:00`
        vm.query.EndTime = new Date()
        vm.getOrders()
      }
    })
  },
  methods: {
    GetData(orderId) {
      var _self = this
      Order.getContractData({ Id: orderId }).then((res) => {
        if (res.status === 'success') {
          _self.contractInfo = res.content
        } else {
          _self.$message.error('合同获取失败!')
        }
      })
    },

    //设置信息来源
    selOnline(val) {
      var _self = this
      _self.detail.OnLine = val
      if (val) {
        _self.detail.Other = ''
        _self.detail.Offline = ''
        _self.detail.Personal = ''
      }
    },
    OtherChange(val) {
      var _self = this
      _self.detail.Other = val
      if (val) {
        _self.detail.OnLine = ''
        _self.detail.Offline = ''
        _self.detail.Personal = ''
      }
    },
    OfflineChange(val) {
      var _self = this
      _self.detail.Offline = val
      if (val) {
        _self.detail.OnLine = ''
        _self.detail.WeChatAccount = ''
        _self.detail.Personal = ''
        _self.detail.Other = ''
      }
    },
    PersonalChange(val) {
      var _self = this
      _self.detail.Personal = val
      if (val) {
        _self.detail.OnLine = ''
        _self.detail.WeChatAccount = ''
        _self.detail.Offline = ''
        _self.detail.Other = ''
      }
    },
    WeChatAccountChange(val) {
      var _self = this
      _self.detail.WeChatAccount = val
      if (val) {
        _self.detail.Offline = ''
        _self.detail.Personal = ''
      }
    },

    //成人个数变化时
    AdultCountChange(val) {
      var _self = this
      _self.detail.AdultCount = parseInt(val)
      // _self.detail.TotoalCount =
      //   parseInt(_self.detail.AdultCount) + parseInt(_self.detail.ElderlyCount) + parseInt(_self.detail.ChildrenCount)
      _self.detail.AllPrice =
        (parseInt(_self.detail.AdultCount) * parseFloat(_self.detail.AdultPrice)) +
        (parseInt(_self.detail.ChildrenCount) * parseFloat(_self.detail.ChildrenPrice)) +
        (parseInt(_self.detail.ElderlyCount) * parseFloat(_self.detail.ElderlyPrice));
    },
    ChildrenCountChange(val) {
      var _self = this
      _self.detail.ChildrenCount = parseInt(val)
      // _self.detail.TotoalCount =
      //   parseInt(_self.detail.AdultCount) + parseInt(_self.detail.ElderlyCount) + parseInt(_self.detail.ChildrenCount)
       _self.detail.AllPrice =
        (parseInt(_self.detail.AdultCount) * parseFloat(_self.detail.AdultPrice)) +
        (parseInt(_self.detail.ChildrenCount) * parseFloat(_self.detail.ChildrenPrice)) +
        (parseInt(_self.detail.ElderlyCount) * parseFloat(_self.detail.ElderlyPrice));
    },
    ElderlyCountChange(val) {
      var _self = this
      _self.detail.ElderlyCount = parseInt(val)
      // _self.detail.TotoalCount =
      //   parseInt(_self.detail.AdultCount) + parseInt(_self.detail.ElderlyCount) + parseInt(_self.detail.ChildrenCount)
       _self.detail.AllPrice =
        (parseInt(_self.detail.AdultCount) * parseFloat(_self.detail.AdultPrice)) +
        (parseInt(_self.detail.ChildrenCount) * parseFloat(_self.detail.ChildrenPrice)) +
        (parseInt(_self.detail.ElderlyCount) * parseFloat(_self.detail.ElderlyPrice));
    },

    //成人价格变化时
    AdultPriceChange(val) {
      var _self = this
      _self.detail.AdultPrice = parseFloat(val)
       _self.detail.AllPrice =
        (parseInt(_self.detail.AdultCount) * parseFloat(_self.detail.AdultPrice)) +
        (parseInt(_self.detail.ChildrenCount) * parseFloat(_self.detail.ChildrenPrice)) +
        (parseInt(_self.detail.ElderlyCount) * parseFloat(_self.detail.ElderlyPrice));
    },
    ChildrenPriceChange(val) {
      var _self = this
      _self.detail.ChildrenPrice = parseFloat(val)
      _self.detail.AllPrice =
        (parseInt(_self.detail.AdultCount) * parseFloat(_self.detail.AdultPrice)) +
        (parseInt(_self.detail.ChildrenCount) * parseFloat(_self.detail.ChildrenPrice)) +
        (parseInt(_self.detail.ElderlyCount) * parseFloat(_self.detail.ElderlyPrice));
    },
    ElderlyPriceChange(val) {
      var _self = this
      _self.detail.ElderlyPrice = parseFloat(val)
      _self.detail.AllPrice =
        (parseInt(_self.detail.AdultCount) * parseFloat(_self.detail.AdultPrice)) +
        (parseInt(_self.detail.ChildrenCount) * parseFloat(_self.detail.ChildrenPrice)) +
        (parseInt(_self.detail.ElderlyCount) * parseFloat(_self.detail.ElderlyPrice));
    },

    PlayTimeFocus() {
      this.detail.PlayTime = ''
    },

    //获取订单
    getOrders() {
      this.query.PageSize = this.pagination.PageSize;
      this.query.PageIndex = this.pagination.PageIndex;
      this.loadingTable=true;
      Order.listOrders(this.query).then((res) => {
        if (res.status === 'success') {
          this.pagination.total = res.content.Total
          this.tableData = res.content.OnePageData
        } else {
          this.$message.error('列表获取失败!')
        }
        this.loadingTable=false;
      })
    },
    //提交修改
    submitForm(formName) {
      var _self = this;
      
      for (var key in _self.detail) {
        if (
          (_self.detail[key] == undefined || _self.detail[key].toString().trim().length == 0) &&
          _self.config[key] != undefined
        ) {
          _self.$message.error(_self.config[key] + '未填写')
          return
        }
      }
      let flag = false
      _self.detail.newListTourist.forEach((item) => {
        if (
          item.Name == '' ||
          item.Name == undefined ||
          // item.Tel == '' ||
          // item.Tel == undefined ||
          item.IDNumber == '' ||
          item.IDNumber == undefined
        ) {
          _self.$message.error('游客信息未填写完整');
          flag = true
          return false
        }
      })
      if (flag) {
        return
      }
      if (parseInt(_self.detail.TotoalCount) != parseInt(_self.detail.newListTourist.length)) {
        // _self.$message.error("同行人数不能大于游客信息数量!");
        _self.$message.error('同行总人数与录入游客信息数量不符合!')
        return false
      }
      if (
        _self.detail.ElderlyCount + _self.detail.ChildrenCount + _self.detail.AdultCount !=
        _self.detail.TotoalCount
      ) {
        _self.$message.error('票价人数错误!')
        return false
      }
      if (new Date(_self.detail.PlayTime).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
        _self.$message.error('游玩日期不能小于当前时间!')
        return false
      }
      if (!_self.mainSelected) {
        _self.$message.error('请选择一位团队负责人!')
        return false
      }

      Order.updateOrder(_self.detail).then((res) => {
        if (res.status === 'success') {
          _self.$message.success('修改成功!')
          _self.flag = 0
          _self.getOrders()
        } else {
          _self.$message.error(res.msg)
        }
      })

      // var _self = this;
      // _self.$refs[formName].validate().then((success) => {
      //   if (success) {
      //     if (
      //       parseInt(_self.detail.TotoalCount) !=
      //       parseInt(_self.detail.newListTourist.length)
      //     ) {
      //       // _self.$message.error("同行人数与游客信息不符！");
      //       _self.$message.error("同行总人数与录入游客信息数量不符合!");
      //       return false;
      //     }
      //     if (
      //       _self.detail.ElderlyCount +
      //         _self.detail.ChildrenCount +
      //         _self.detail.AdultCount !=
      //       _self.detail.TotoalCount
      //     ) {
      //       _self.$message.error("票价人数错误！");
      //       return false;
      //     }
      // if (new Date(_self.form.PlayTime).setHours(0, 0, 0, 0) < new Date().setHours(0, 0, 0, 0)) {
      //   _self.$message.error('游玩日期不能小于当前时间!')
      //   return false
      // }
      //     // if (!this.mainSelected) {
      //     //   this.$message.error("请选择主要游客");
      //     //   return false;
      //     // }
      //     Order.updateOrder(_self.detail).then((res) => {
      //       if (res.status === "success") {
      //         _self.$message.success("修改成功!");
      //         _self.flag = 0;
      //         _self.getOrders();
      //       } else {
      //         _self.$message.error(res.msg);
      //       }
      //     });
      //   } else {
      //     _self.$message.error("请补全信息!");
      //   }
      // });
    },
    resetForm(formName) {
      if (formName === 'queryForm') {
        this.query = {
          RegimentNo: '',
          ContractNo:'',
          lineName: '',
          StartTime: '',
          EndTime: '',
          PageSize: 10,
          PageIndex: 1,
        }
        this.getOrders()
      }
    },
    //取消订单
    cancelOrder(row) {
      Order.cancelOrder({ Id: row.Id }).then((res) => {
        if (res.status === 'success') {
          this.$message.success('取消成功')
          this.getOrders()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    exportTable() {},
    //获取详情信息
    getDetail(row) {
      var _self = this;
      _self.loadingLook=true;
      Order.getDetail({ Id: row.Id }).then((res) => {
        if (res.status === 'success') {
          _self.detail.orderId = row.Id
          _self.GetData(_self.detail.orderId)
          _self.detail.Status = res.content.order.Status
          _self.detail.LineId = res.content.order.LineId
          _self.detail.LineName = res.content.line.Name
          _self.detail.PlayTime = dateFormat(res.content.order.PlayTime)
          // _self.detail.EndTime = dateFormat(
          //   new Date(res.content.order.PlayTime).getTime() + res.content.line.DayCount * 60 * 60 * 24 * 1000
          // )


          _self.detail.TotoalCount = res.content.order.TotoalCount
          _self.detail.ChildrenCount = res.content.order.ChildrenCount
          _self.detail.ElderlyCount = res.content.order.ElderlyCount

          _self.detail.RestaurantName = res.content.order.RestaurantName
          _self.detail.RestaurantPrice = res.content.order.RestaurantPrice
          _self.detail.AllPrice = res.content.order.AllPrice
          _self.detail.AdultPrice = res.content.order.AdultPrice
          _self.detail.AdultCount = res.content.order.AdultCount
          _self.detail.ChildrenPrice = res.content.order.ChildrenPrice
          _self.detail.ElderlyPrice = res.content.order.ElderlyPrice

          _self.detail.OnLine = res.content.order.OnLine
          _self.detail.Other = res.content.order.Other
          _self.detail.Offline = res.content.order.Offline
          _self.detail.WeChatAccount = res.content.order.WeChatAccount
          _self.detail.Personal = res.content.order.Personal

          if (res.content.mainTourist !== null) {
            //设置游客
            _self.detail.newListTourist = res.content.mainTourist.AllTourist.map((v) => {
              return {
                Id: v.Id,
                Name: v.Name,
                Tel: v.Tel,
                IDNumber: v.IDNumber,
                CertificatesType:v.CertificatesType,
                IsMain: v.Id == res.content.mainTourist.TouristId,
              }
            })
          }
          //设置行程项目
          if (Array.isArray(res.content.lineDetail)) {
            _self.table = res.content.lineDetail.map((v, i) => {
              return {
                id: i,
                arrangement: [...v.dataList],
              }
            })

            var tableTemp = res.content.lineDetail.map((v, i) => {
              return {
                id: i,
                arrangement: [
                  ...v.dataList.map((pro) => {
                    return {
                      Id: pro.PointId,
                      Name: pro.Projects,
                      Time: [
                        `${parseInt(pro.StartTime / 60)}:${(pro.StartTime % 60).toString().padStart(2, '0')}`,
                        `${parseInt(pro.EndTime / 60)}:${(pro.EndTime % 60).toString().padStart(2, '0')}`,
                      ],
                    }
                  }),
                ],
              }
            })

            _self.detail.EndTime=new Date(res.content.order.PlayTime).getTime() + (res.content.line.DayCount - 1) * 60 * 60 * 24 * 1000;
            //最后一天的结束时间
            var end = tableTemp[tableTemp.length - 1].arrangement[tableTemp[tableTemp.length - 1].arrangement.length - 1].Time[1];
            var kk = _self.formatDate(_self.detail.EndTime) + ' ' + end;
            _self.detail.EndTime=kk;
          }

          _self.flag = 1;
        } else {
          _self.$message.error('信息获取失败!')
        }
        _self.loadingLook=false;
      })
    },
    //日期时间格式转换
    formatDate(time) {
      let date = new Date(time)
      let Y = date.getFullYear() + '-'
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-'
      let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' '
      let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':'
      let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':'
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return Y + M + D
    },
    //删除订单
    deleteOrder(row) {
      Order.deleteOrder({ Id: row.Id }).then((res) => {
        if (res.status === 'success') {
          this.$message.success('删除成功!')
          this.getOrders()
        } else {
          this.$message.error(res.msg)
        }
      })
    },

    //设置路线详情
    setRouteInfo(Id) {
      ROUTE.getRouteDetail({ Id }).then((res) => {
        if (res.status === 'success') {
          if (Array.isArray(res.content.dataAll)) {
            this.table = res.content.dataAll.map((v, i) => {
              return {
                id: i,
                arrangement: [...v.dataList],
              }
            })
          }
        } else {
          this.$message.error('线路详情获取失败')
        }
      })
      //设置路线信息，设置model.startPoint  model.endPoint
      //根据路线中的CompanyId  发送请求得到CompanyId name 门店列表
    },
    //子表操作
    switchSubtable(subId) {
      this.currentSubId = subId
    },
    //设置主要游客
    switchMainVisitor(item) {
      this.mainSelected = item.IsMain
      if (!item || !item.Tel) {
        item.IsMain = false
        return false
      }
      this.detail.newListTourist.forEach((v) => {
        if (v.Tel !== item.Tel) v.IsMain = false
      })
    },
    //游客操作
    handleVisitor(type) {
      if (type === 'plus') {
        this.detail.TotoalCount++
        this.detail.newListTourist.push({
          Name: '',
          Tel: '',
          IDNumber: '',
          CertificatesType:'身份证',
          IsMain: false,
        })
      } else if (type === 'minus') {
        if (this.detail.newListTourist.length > 1) {
          this.detail.TotoalCount--
          this.detail.newListTourist.pop()
        } else {
          this.$message.error('至少录入一位游客信息!')
        }
      }
    },
    handlePageSize(value) {
      this.pagination.PageSize = value
    },
    handlePageIndex(value) {
      this.pagination.PageIndex = value
    },
  },
  watch: {
    'pagination.PageSize': function() {
      this.getOrders()
    },
    'pagination.PageIndex': function() {
      this.getOrders()
    },
  },
  mounted() {
    this.sessionId = getCookie('sessionId')
  },
}
</script>
<style>
.el-input.is-disabled .el-input__inner {
  background-color: #fff !important;
  color: #606266 !important;
}
</style>
<style scoped lang="less">
.btn {
  margin: 50px 0;
  width: 100%;
}
.main-left {
  width: 40%;
  min-width: 620px;
  border-right: 1px solid #ddd;
}
.main-left .left-table {
  height: 753px;
  background: chocolate;
}
.main-left .left-pagination {
  height: 40px;
  background: #dedede;
  text-align: center;
}
.left-pagination .pagination-bottom {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.main-right {
  flex: 1;
}
.right-table {
  padding: 20px;
  padding-bottom: 78px;
}
.input-form {
  position: relative;
  width: 95%;
  min-width: 1000px;
  border-collapse: collapse;
  border: 1px solid #aaa;
  thead {
    // width: 100%;
    background-color: #f1f1f1;
    border: 1px solid #aaa;
  }
  th,
  tr {
    height: 33px;
    border: 1px solid #aaa;
  }
  td,
  th {
    text-align: center;
    vertical-align: middle;
    border: 1px solid #aaa;
  }
}
.sub-selected {
  background: cornflowerblue;
}
.subtable-tab {
  position: absolute;
  top: 370px;
  left: 0;
  width: 100%;
  height: 45px;
  overflow: auto hidden;
  border-left: 1px solid #aaa;
  border-right: 1px solid #aaa;
  display: flex;
  // background: red;
}
.subtable-tab .tab-item {
  border-right: 1px solid #aaa;
  min-width: 60px;
  height: 45px;
  line-height: 45px;
  text-align: center;
}

.subtable-tab1 {
  position: absolute;
  top: 390px;
  left: 0;
  width: 100%;
  height: 45px;
  overflow: auto hidden;
  border-left: 1px solid #aaa;
  border-right: 1px solid #aaa;
  display: flex;
  // background: red;
}
.subtable-tab1 .tab-item {
  border-right: 1px solid #aaa;
  min-width: 60px;
  height: 45px;
  line-height: 45px;
  text-align: center;
}

.emphasis {
  font-weight: bolder;
}
.input-form /deep/ .el-input__inner,
.input-form /deep/ .el-input-number,
.input-form /deep/ .el-select {
  border: none;
  width: 100%;
}
</style>
